import { render, staticRenderFns } from "./logo_text.vue?vue&type=template&id=0358307b&"
var script = {}
import style0 from "./logo_text.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports